import * as React from "react"
import { create } from "zustand"

type MobileFormScreenState = {
  /** How many full-screen phone forms are mounted (a counter, so one leaving as another arrives never flickers). */
  screens: number
  add: () => void
  remove: () => void
}

export const useMobileFormScreenStore = create<MobileFormScreenState>((set) => ({
  screens: 0,
  add: () => set((state) => ({ screens: state.screens + 1 })),
  remove: () => set((state) => ({ screens: Math.max(0, state.screens - 1) })),
}))

/** While a phone form is open, the app header steps aside: the form has its own top bar. */
export function useRegisterMobileFormScreen(enabled = true) {
  const add = useMobileFormScreenStore((state) => state.add)
  const remove = useMobileFormScreenStore((state) => state.remove)
  React.useEffect(() => {
    if (!enabled) return
    add()
    return remove
  }, [add, enabled, remove])
}

/** Whether a full-screen phone form is showing (the app header reads this to hide itself). */
export function useIsMobileFormScreenOpen() {
  return useMobileFormScreenStore((state) => state.screens > 0)
}
